import * as types from './mutation-types'
import backup from '.'
export default {
    [types.BOOTSTRAP_BACKUPS](state, backups) {
        state.backups = backups
    },

    [types.SET_TOTAL_BACKUPS](state, totalBackups) {
        state.totalBackups = totalBackups
    },
    [types.DELETE_BACKUP](state, file_name) {
        let index = state.backups.findIndex(backup => backup.file_name === file_name)
        state.backups.splice(index, 1)
    },
    [types.ADD_BACKUP](state, data) {
        state.backups.push(data.backup)
    },
    [types.DELETE_MULTIPLE_BACKUPS](state, selectedBackups) {
        selectedBackups.forEach((backup) => {
            let index = state.backups.findIndex(_backup => _backup.file_name === backup.file_name)
            state.backups.splice(index, 1)
        })

        state.selectedBackups = []
    },
    [types.SET_SELECTED_BACKUPS](state, data) {
        state.selectedBackups = data
    },

    [types.SET_SELECT_ALL_STATE](state, data) {
        state.selectAllField = data
    },
    [types.SET_SELECT_ALL_STATE](state, data) {
        state.selectAllField = data
    },
}